export const checkLocation = () => {
    return fetch('https://location.xr.health/current_location.json', {
    }).then(res => res.json());
}
